import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfigService, GeoZoneService, AppDataService } from 'app/services';
import { CustomWindow } from 'app/@types';

declare let window: CustomWindow;

@Component({
    selector: 'sidebar-menu',
    templateUrl: './sidebar-menu.component.html',
    styleUrls: ['./sidebar-menu.component.scss'],
    providers: [MessageService]
})

export class SideBarMenuComponent implements OnInit {
    public geoZones: Array<any> = [];
    public selectGeoZone: any;
    set _selectGeoZone(value: any) {
        this.selectGeoZone = value;
        this.changedGeoZone(value);
    }
    public isVisibleAreaNotActiveModal: boolean = false;

    @Output() changedGeoZoneEmit = new EventEmitter<any>();
    changedGeoZone(item: any) {
        if (!item.PolygonGeometries){
            this.isVisibleAreaNotActiveModal = true;
        }
        else {
            this.changedGeoZoneEmit.emit(item);
        }
    }

    constructor(public configService: ConfigService,
        public geoZoneService: GeoZoneService,
        private messageService: MessageService, public appData: AppDataService) { }

    ngOnInit(): void {
        this.getGeoZones();
    }

    public getGeoZones() {
        this.geoZoneService.getGeoZones(null, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.geoZones = data.GeoZones;

                if (this.appData.isBoracayLocation) {
                    const boracayItem = this.geoZones.find(item => item.Name === 'Boracay');
                    this.changedGeoZone(boracayItem);
                }
            });

    }
}
